import { useUpdateAutoManagedCampaignMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useQueryHelper } from '@anytag/shared-hooks';
import {
  AutoManagedCampaignForm,
  AutoManagedCampaignFormValues,
  getDefaultAutoManagedCampaignFormValues
} from '@anytag/shared-organisms';
import { FormAction } from '@anytag/shared-types';
import { useAutoManagedCampaignDetailsContext } from '../auto-managed-campaign-details-context';

export const EditAutoManagedCampaign = () => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { autoManagedCampaign, autoManagedCampaignId } = useAutoManagedCampaignDetailsContext();
  const { callUpdateAutoManagedCampaign } = useUpdateAutoManagedCampaignMutation();

  const handleSubmit: FormAction<AutoManagedCampaignFormValues>['onSubmit'] = async (payload) => {
    try {
      await callUpdateAutoManagedCampaign({
        variables: {
          input: {
            status: payload.status,
            campaignId: autoManagedCampaignId,
            serviceInfo: payload.serviceInfo,
            requirement: payload.requirement,
            marginRate: payload.marginRate ? Number(payload.marginRate) / 100 : 0
          }
        }
      });
      enqueueSnackbar(t('succeededInUpdating', { name: payload.title }), { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(t('failedToUpdate', { name: payload.title }), { variant: 'error' });
      enqueueSnackbar(t(error || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <AutoManagedCampaignForm
      onSubmit={handleSubmit}
      defaultValues={getDefaultAutoManagedCampaignFormValues(autoManagedCampaign)}
    />
  );
};
